const ACCOUNT_ID_PATTERN = /\d{6,}/g;

export const getCanonicalURL = () => {
  const canonical = document.querySelector('link[rel="canonical"]')?.getAttribute('href');

  if (canonical) {
    return canonical;
  }

  const { origin, pathname } = globalThis.location;

  return `${origin}${pathname}`;
};

export const getPageLanguage = () => {
  const lang = document.documentElement.lang?.split('-')[0];

  return lang || 'en';
};

export const getPageName = (siteEditorTitle = '') => {
  if (siteEditorTitle) {
    return siteEditorTitle;
  }

  return document.title || '';
};

export const getFriendlyName = () => {
  const { pathname } = globalThis.location;
  const myAccountIndex = pathname.indexOf('/my-account');

  if (myAccountIndex === -1) {
    return pathname
      .replace(/^\//, '')
      .replace(/\//g, '-')
      .replace(ACCOUNT_ID_PATTERN, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  return pathname
    .slice(myAccountIndex + 1)
    .replace(/^\//, '')
    .replace(/\//g, '-')
    .replace(ACCOUNT_ID_PATTERN, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
};

export const boolToAdobeString = (value) => {
  if (value === true || value === 'true') {
    return 'true';
  }

  return 'false';
};
